/**
 * Builds a full UpdateFormDto from a FormResponse for PUT requests.
 * The API expects the whole body on update; use overrides to merge in changed fields.
 */
export function formResponseToUpdateDto(form, overrides) {
    const dto = {
        name: form.name,
        companyName: form.companyName ?? undefined,
        siteId: form.siteId ?? undefined,
        jobId: form.jobId ?? undefined,
        contactId: form.contactId ?? undefined,
        data: form.data ?? undefined,
        status: form.status,
        notes: form.notes ?? undefined,
        reviewedById: form.reviewedById ?? undefined,
        reviewedByName: form.reviewedByName ?? undefined,
    };
    return overrides ? { ...dto, ...overrides } : dto;
}
